import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./common/Footer";
import Header from "./common/Header";
import SliderTirthYatra from './sliders/tirthyantra/SliderTirthYatra';
import Slider_2_TirthYatra from './sliders/tirthyantra/Slider_2_TirthaYatra';
import LoginPopup from "./popup/LoginPopup";
import SEO from "../components/common/SEO";
import useFrontendPageContent from "../components/common/useFrontendPageContent";
import DynamicSectionTitle from "../components/common/DynamicSectionTitle";

import axios from 'axios';

function TirthYatra() {
    const { getSection, isSectionActive } = useFrontendPageContent('tirth-yatra');
    const journeysSection = getSection('spiritual_journeys', {
        title: 'Spiritual Journeys Across Incredible India',
    });
    const mostSoughtSection = getSection('most_sought_tours', {
        title: 'Start Journey to Enlightenment With Most Sought Tours',
        subtitle: 'Embark on an unparalleled odyssey of spirituality with our specially-curated tour packages',
    });
    const benefitsSection = getSection('benefits', {
        title: 'Benefits of Booking With Us',
        subtitle: 'Discover the unrivalled benefits that promise memorable journeys all along.',
        Items: [
            { title: 'Reasonable Prices', description: 'Get Unique holiday packages at cost-effective prices like never before.', image_url: 'assets/img/tours/why-us/itinerary.png' },
            { title: 'Instant Bookings', description: 'Enjoy Fast-paced booking on your desired destination with ease.', image_url: 'assets/img/tours/why-us/price.png' },
            { title: 'Guided Tours', description: 'Have personalised travelling experience with additional guide assistance.', image_url: 'assets/img/tours/why-us/deal.png' },
            { title: '24/7 Customer Support', description: 'Connect with our experts and get 24/7 continuous guidance on your tour.', image_url: 'assets/img/tours/why-us/customer-service.png' },
        ],
    });

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

    const searchStyles = `
.search-container { position: relative; width: 100%; }
.suggestions-dropdown { position: absolute; top: 100%; left: 0; right: 0; background-color: white; border: 1px solid #ddd !important; border-top: none; border-radius: 0 0 8px 8px; z-index: 9999 !important; max-height: 300px; overflow-y: auto; text-align: left; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border-radius:0 0 0 30px; }
.suggestion-item { padding: 12px 20px; cursor: pointer; border-bottom: 1px solid #eee; }
.suggestion-item:last-child { border-bottom: none; }
.suggestion-item:hover { background-color: #f5f5f5; }
.suggestion-item strong { color: #333; }
.suggestion-item small { color: #888; margin-left: 8px; text-transform: capitalize; }
`;

    const generateYatraSlug = (yatra) => {
        if (!yatra) return '';
        const slugify = (str) => str ? str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '') : '';
        const parts = [
            slugify(yatra.yatra_name),
            slugify(yatra.city),
            Math.round(yatra.offer_price || yatra.yatra_price || 0),
            yatra.id
        ].filter(Boolean).join('-');
        return parts.replace(/--+/g, '-');
    };

    const navigate = useNavigate();
    const location = useLocation();

    // Search state
    const [searchQuery, setSearchQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [isSuggestionsLoading, setIsSuggestionsLoading] = useState(false);

    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.innerText = searchStyles;
        document.head.appendChild(styleSheet);
        return () => {
            if (styleSheet.parentNode) document.head.removeChild(styleSheet);
        };
    }, [location]);

    useEffect(() => {
        if (searchQuery.trim().length < 2) {
            setSuggestions([]);
            return;
        }
        const debounceTimer = setTimeout(() => {
            const fetchSuggestions = async () => {
                setIsSuggestionsLoading(true);
                try {
                    const response = await axios.get(`${API_BASE_URL}/yatras/search-yatras?q=${encodeURIComponent(searchQuery)}`);
                    const yatras = Array.isArray(response.data?.yatras) ? response.data.yatras : [];

                    const citySet = new Set();
                    const citySuggestions = [];
                    for (const y of yatras) {
                        const city = (y.city || '').trim();
                        if (city && !citySet.has(city.toLowerCase())) {
                            citySet.add(city.toLowerCase());
                            citySuggestions.push({ type: 'city', id: null, name: city });
                        }
                    }

                    const yatraSuggestions = yatras.map(y => ({
                        type: 'yatra',
                        id: y.id,
                        name: y.yatra_name,
                        city: y.city,
                        price: y.yatra_price,
                        yatra: y,
                    }));

                    setSuggestions([...citySuggestions, ...yatraSuggestions]);
                } catch (error) {
                    console.error("Failed to fetch yatra suggestions:", error);
                    setSuggestions([]);
                } finally {
                    setIsSuggestionsLoading(false);
                }
            };
            fetchSuggestions();
        }, 300);
        return () => clearTimeout(debounceTimer);
    }, [searchQuery]);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/yatra-list?city=${encodeURIComponent(searchQuery.trim())}`);
            setSuggestions([]);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setSearchQuery(suggestion.name || '');
        setSuggestions([]);
        if (suggestion.type === 'city') {
            navigate(`/yatra-list?city=${encodeURIComponent(suggestion.name)}`);
        } else if (suggestion.type === 'yatra') {
            navigate(`/yatra-details/${generateYatraSlug(suggestion.yatra)}`);
        }
    };

    function updateClassBasedOnScreenSize() {
        const element = document.querySelector(".tirthyatra-page");
        if (!element) return;

        if (window.innerWidth >= 1024) {
            element.classList.add("pt-4");
            element.classList.add("mb-5");

        } else {
            element.classList.remove("pt-4");
            element.classList.add("mb-2");

        }

        const element_1 = document.querySelector(".tirthyatra-page_1");
        if (!element_1) return;

        if (window.innerWidth >= 1024) {
            element_1.classList.add("pt-4");
            element_1.classList.add("mb-5");

        } else {
            element_1.classList.remove("pt-4");
            element_1.classList.add("mb-2");

        }


    }

    window.addEventListener("load", updateClassBasedOnScreenSize);
    window.addEventListener("resize", updateClassBasedOnScreenSize);



    const allDestinations = [
        {
            id: 1,
            name: "Maharashtra",
            imgSrc: "assets/img/pilgrimage/state/maharashtra.png",
            link: "/yatra-list",
            description: "Nasik, Shirdi, Mahabaleshwar, Nanded, Kolhapur, Pandharpur, Jejuri...",
        },
        {
            id: 2,
            name: "Telangana",
            imgSrc: "assets/img/pilgrimage/state/telangana.png",
            link: "/yatra-list",
            description: "Calvary Temple, Birla Mandir, Chilkur Balaji Temple, Hare Krishna Golden Temple...",
        },
        {
            id: 3,
            name: "Tamil Nadu",
            imgSrc: "assets/img/pilgrimage/state/tamilnadu.png",
            link: "/yatra-list",
            description: "Kapaleeshwarar Temple, San Thome Church, Vadapalani Murugan...",
        },
        {
            id: 4,
            name: "West Bengal",
            imgSrc: "assets/img/pilgrimage/state/west-bengal.png",
            link: "/yatra-list",
            description: "Dakshineswar, Birla Temple, Ramakrishna Math, Shri Mahalaxmi Temple...",
        },
        {
            id: 5,
            name: "Rajasthan",
            imgSrc: "assets/img/pilgrimage/state/rajasthan.png",
            link: "/yatra-list",
            description: "Govind Devji Temple, Akshardham Temple, Moti Dungari Temple...",
        },
        {
            id: 6,
            name: "Haryana",
            imgSrc: "assets/img/pilgrimage/state/haryana.png",
            link: "/yatra-list",
            description: "Sheetla Mata Mandir, Gurudwara Nada Sahib, Mata Mansa Devi Mandir...",
        },
        {
            id: 7,
            name: "Gujarat",
            imgSrc: "assets/img/pilgrimage/state/gujarat.png",
            link: "/yatra-list",
            description: "Somnath, Swaminarayan Akshardham, Nageshwar, Girnar, Bai Harir, Dwarka...",
        },
        {
            id: 8,
            name: "Uttar Pradesh",
            imgSrc: "assets/img/pilgrimage/state/uttar-pradesh.png",
            link: "/yatra-list",
            description: "Sarnath, Kashi Vishwanath, Prem Mandir, Banaras Ghats, Banke Bihari...",
        },
        {
            id: 9,
            name: "Punjab",
            imgSrc: "assets/img/pilgrimage/state/punjab.png",
            link: "/yatra-list",
            description: "Golden Temple, Gurudwara, Durgiana Temple, Ram Tirath, Mukteshwar...",
        },
        {
            id: 10,
            name: "Andhra Pradesh",
            imgSrc: "assets/img/pilgrimage/state/andhra-pradesh.png",
            link: "/yatra-list",
            description: "Tirumala Temple, Mallikarjuna, Srivari Mettu, Srikalahasthi Temple...",
        },
        {
            id: 11,
            name: "Arunachal Pradesh",
            imgSrc: "assets/img/pilgrimage/state/arunachal-pradesh.png",
            link: "/yatra-list",
            description: "Tawang Buddhist Monastery, Parashuram Kunda, Gorsam Chorten...",
        },
        {
            id: 12,
            name: "Assam",
            imgSrc: "assets/img/pilgrimage/state/assam.png",
            link: "/yatra-list",
            description: "Kamakhya Temple, Sri Umananda Temple, Tilinga Mandir Temple...",
        },
        {
            id: 13,
            name: "Bihar",
            imgSrc: "assets/img/pilgrimage/state/Bihar.png",
            link: "/yatra-list",
            description: "Mahabodhi Temple, Hanuman Mandir, Vishnupad Temple, Nalanda...",
        },
        {
            id: 14,
            name: "Chhattisgarh",
            imgSrc: "assets/img/pilgrimage/state/chhattisgarh.png",
            link: "/yatra-list",
            description: "Jatmai Temple, Maa Bambleshwari Temple, Deorani-Jethani Temple...",
        },
        {
            id: 15,
            name: "Goa",
            imgSrc: "assets/img/pilgrimage/state/Goa.png",
            link: "/yatra-list",
            description: "Basilica of Bom Jesus, Mangeshi Temple, Tambadi Surla Mahadev Temple...",
        },
        {
            id: 16,
            name: "Himachal Pradesh",
            imgSrc: "assets/img/pilgrimage/state/himachal-pradesh.png",
            link: "/yatra-list",
            description: "Hidimba Devi Temple, Manikaran Gurudwara, Dalai Lama Temple...",
        },
        {
            id: 17,
            name: "Jammu and Kashmir",
            imgSrc: "assets/img/pilgrimage/state/jammu-and-kashmir.png",
            link: "/yatra-list",
            description: "Vaishno Devi Mandir, Amarnath Cave, Nau Devi Temple, Avantiswami Temple...",
        },
        {
            id: 18,
            name: "Jharkhand",
            imgSrc: "assets/img/pilgrimage/state/jharkhand.png",
            link: "/yatra-list",
            description: "Baba Baidyanath Temple, Basukinath Temple, Deori Mandir, Pahari Mandir...",
        },
    ];

    const tirthYatraExploreGems = getSection('tirth_yatra_explore_gems', {
        title: 'The Hidden Gems',
        title_highlight: 'Explore',
    });
    const topPilgrimage = getSection('top_pilgrimage', { title: 'Sites of India', title_highlight: 'Explore Top Pilgrimage' });

    const allDestinationsMerged = journeysSection.Items && journeysSection.Items.length > 0
        ? journeysSection.Items.map((item, index) => ({
            id: item.id || index + 1,
            name: item.title || item.name,
            imgSrc: item.image_url || item.imgSrc || item.image,
            link: item.link_url || item.link || "/yatra-list",
            description: item.description,
        }))
        : allDestinations;

    const [visibleDestinations, setVisibleDestinations] = useState(allDestinationsMerged.slice(0, 9));

    const loadMore = () => {
        const currentLength = visibleDestinations.length;
        const nextDestinations = allDestinationsMerged.slice(currentLength, currentLength + 6);
        setVisibleDestinations([...visibleDestinations, ...nextDestinations]);
    };

    return (
        <div>
            <SEO title="Spiritual Tirth Yatra & Pilgrimage Tours | Mangoloops" description="Embark on a sacred journey with Mangoloops. Explore our specially curated Tirth Yatra and pilgrimage tour packages across Incredible India." />
            <LoginPopup />
            <Header />
            <div className="banner-content tour-search-sec text-center mb-5 mb-lg-8" style={{ backgroundImage: "url('assets/img/pilgrimage/banner.webp" }}>
                <div className=" container-fluid ">
                    <div className=" row justify-content-center py-xl-4">

                        <div className=" col-lg-8">
                            <div className="card-body">

                                <form className="form-container search-input-form" onSubmit={handleSearchSubmit}>

                                    <div className="search-container">
                                        <span><i className="fa fa-search search-icon"></i></span>
                                        <input
                                            type="text"
                                            placeholder="Enter City or Yatra name"
                                            className="search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            autoComplete="off"
                                        />
                                        <button type="submit" className="search-button">Search</button>

                                        {isSuggestionsLoading && (
                                            <div className="suggestions-dropdown"><div className="suggestion-item">Loading...</div></div>
                                        )}

                                        {!isSuggestionsLoading && suggestions.length > 0 && (
                                            <div className="suggestions-dropdown">
                                                {suggestions.map((item, index) => (
                                                    <div
                                                        key={`${item.type}-${item.id || index}`}
                                                        className="suggestion-item"
                                                        onMouseDown={() => handleSuggestionClick(item)}
                                                    >
                                                        <strong>{item.name}</strong>
                                                        {item.type === 'yatra' && item.city && (
                                                            <small>Yatra - {item.city}</small>
                                                        )}
                                                        {item.type === 'city' && <small>City</small>}
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {!isSuggestionsLoading && suggestions.length === 0 && searchQuery.trim().length >= 2 && (
                                            <div className="suggestions-dropdown">
                                                <div className="suggestion-item text-muted">
                                                    No results found for "{searchQuery}"
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </form>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


            {isSectionActive('top_pilgrimage') && <SliderTirthYatra section={topPilgrimage} />}

            {/************* */}

            {isSectionActive('spiritual_journeys') && (
                <section className="container offers holidays-left">
                    <div className="popular-state pb-0 tirthyatra-page">
                        <div className="container">
                            <div className="title">
                                <DynamicSectionTitle section={journeysSection} className="pb-0" />
                            </div>
                        </div>
                    </div>

                    <div className="_polrdestnbx mt20 pl-2">
                        {visibleDestinations.map((dest) => (
                            <div className="ecpl_rbx" key={dest.id}>
                                <div className="mgdestn">
                                    <a href={dest.link}>
                                        <img src={dest.imgSrc} alt={dest.name} />
                                    </a>
                                </div>
                                <div className="_pckgdscrptn">
                                    <h5 className="htlnking">
                                        <a href={dest.link}>{dest.name}</a>
                                    </h5>
                                    <div className="htlnking">
                                        <a href={dest.link}>{dest.description}</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {visibleDestinations.length < allDestinationsMerged.length && (
                        <div className="text-center mt-4">
                            <button className="btn btn-primary" onClick={loadMore} style={{ cursor: "pointer" }}>
                                Load More
                            </button>
                        </div>
                    )}

                </section>
            )}

            {/************** */}

            {isSectionActive('most_sought_tours') && (
                <div className="container swiper pt-5 pb-5 holidays-left">

                    <div className="popular-state pb-0 pt-0 mb-5">
                        <div className="container">
                            <div className="title">
                                <DynamicSectionTitle section={mostSoughtSection} className="pb-0" />
                                <p>{mostSoughtSection.subtitle}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row desktop-view">
                        {(mostSoughtSection.Items || []).map((item, index) => (
                            <div className="col-lg-4" key={`${item.title}-${index}`}>
                                <div className="">
                                    <div className="team-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                        <div className="team-image">
                                            <a href={item.link_url || "/yatra-list"} className="image-anime">
                                                <figure>
                                                    <img src={item.image_url} alt={item.title} />
                                                </figure>
                                            </a>
                                        </div>

                                        <div className="team-content">
                                            <h3><a className="text-white" href={item.link_url || "/yatra-list"}>{item.title}</a></h3>
                                            <p className="text-white mb-0">{item.description}</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                    <div className="row mobile-view">

                        {(mostSoughtSection.Items || []).map((item, index) => (
                            <div className="col-lg-4 mobile-width-50" key={`mobile-${item.title}-${index}`}>
                                <div className="">
                                    <div className="team-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                        <div className="team-image">
                                            <a href={item.link_url || "/yatra-list"} className="image-anime">
                                                <figure>
                                                    <img className="limited-time-img" src={item.image_url} alt={item.title} />
                                                </figure>
                                            </a>
                                        </div>

                                        <div className="team-content">
                                            <h3><a className="text-white" href={item.link_url || "/yatra-list"}>{item.title}</a></h3>
                                            <p className="text-white mb-0">{item.description}</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            )}

            {isSectionActive('tirth_yatra_explore_gems') && <Slider_2_TirthYatra section={tirthYatraExploreGems} />}

            {/*********** */}

            {isSectionActive('benefits') && (
                <div>
                    <div className="popular-state pb-0 pt-0 mb-5">
                        <div className="container">
                            <div className="title">
                                <DynamicSectionTitle section={benefitsSection} className="pb-0" />
                                <p>{benefitsSection.subtitle}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        {(benefitsSection.Items || []).map((item, index) => (
                            <div className="col-lg-3" key={`${item.title}-${index}`}>
                                <div className="why_bk_box">
                                    <div className="img_box">
                                        <img src={item.image_url || ['assets/img/tours/why-us/itinerary.png', 'assets/img/tours/why-us/price.png', 'assets/img/tours/why-us/deal.png', 'assets/img/tours/why-us/customer-service.png'][index % 4]} alt={item.title} />
                                    </div>
                                    <h4 className="why-our-tour-h4">{item.title}</h4>
                                    <p className="why-our-tour-p">{item.description}</p>
                                </div>
                            </div>
                        ))}

                    </div>

                </div>
            )}


            <Footer />
        </div>
    )
}
export default TirthYatra;
